import * as React from "react";

export const Icons = (): JSX.Element => {
  return (
    <svg
      xmlns="https://www.w3.org/2000/svg"
      style={{ display: "none" }}
      aria-hidden="true"
    >
      <symbol id="twitter" viewBox="0 0 28 22">
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M24.592 5.402c.017.237.017.474.017.71 0 7.226-5.499 15.55-15.55 15.55-3.096 0-5.973-.896-8.392-2.453.44.05.863.068 1.32.068 2.554 0 4.906-.863 6.785-2.335a5.475 5.475 0 01-5.11-3.79c.338.05.676.084 1.032.084.49 0 .981-.068 1.438-.186A5.466 5.466 0 011.75 7.686v-.068c.727.407 1.573.66 2.47.694a5.461 5.461 0 01-2.437-4.551c0-1.016.271-1.946.745-2.758a15.535 15.535 0 0011.269 5.719 6.169 6.169 0 01-.135-1.252A5.463 5.463 0 0119.127.004c1.574 0 2.995.66 3.993 1.726A10.76 10.76 0 0026.59.41a5.45 5.45 0 01-2.403 3.012c1.1-.118 2.166-.423 3.147-.846a11.749 11.749 0 01-2.74 2.826z"
        />
      </symbol>

      <symbol
        id="instagram"
        viewBox="0 0 40 40"
      >
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M20.036 13.2a6.813 6.813 0 00-6.824 6.824 6.813 6.813 0 006.824 6.824 6.813 6.813 0 006.824-6.824 6.813 6.813 0 00-6.824-6.824zm0 11.26a4.445 4.445 0 01-4.437-4.436 4.44 4.44 0 014.437-4.437 4.44 4.44 0 014.436 4.437 4.445 4.445 0 01-4.436 4.436zm8.695-11.54c0 .886-.713 1.592-1.592 1.592a1.592 1.592 0 111.592-1.592zm4.52 1.616c-.102-2.132-.589-4.02-2.15-5.577-1.557-1.556-3.445-2.043-5.578-2.15-2.197-.124-8.784-.124-10.981 0-2.126.101-4.015.588-5.577 2.144-1.562 1.556-2.043 3.445-2.15 5.577-.125 2.198-.125 8.784 0 10.982.101 2.132.588 4.02 2.15 5.576 1.562 1.556 3.445 2.043 5.577 2.15 2.197.125 8.784.125 10.981 0 2.133-.1 4.021-.588 5.577-2.15 1.556-1.556 2.043-3.444 2.15-5.576.125-2.198.125-8.779 0-10.976zm-2.84 13.333a4.492 4.492 0 01-2.53 2.53c-1.752.695-5.91.535-7.845.535-1.936 0-6.1.154-7.846-.535a4.492 4.492 0 01-2.53-2.53c-.695-1.752-.534-5.909-.534-7.845s-.155-6.1.534-7.846a4.491 4.491 0 012.53-2.53c1.752-.695 5.91-.534 7.846-.534s6.1-.155 7.845.534a4.492 4.492 0 012.53 2.53c.695 1.752.535 5.91.535 7.846s.16 6.1-.535 7.845z"
        />
      </symbol>

      <symbol
        id="facebook"
        viewBox="0 0 40 40"
      >
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M17.207 33.333V21.406h-3.874v-4.74h3.874v-3.734c0-4.057 2.404-6.265 5.914-6.265 1.682 0 3.126.13 3.546.187v4.24h-2.435c-1.909 0-2.277.937-2.277 2.307v3.266h4.308l-.591 4.74h-3.718v11.926"
        />
      </symbol>

      <symbol
        id="search"
        viewBox="0 0 24 24"
      >
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M17.075 15.661a7.857 7.857 0 10-1.414 1.414l3.632 3.632a1 1 0 001.414-1.414l-3.632-3.632zm-6.218 1.053a5.857 5.857 0 110-11.714 5.857 5.857 0 010 11.714z"
        />
      </symbol>

      <symbol
        id="account"
        viewBox="0 0 24 24"
      >
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M17 7A5 5 0 117 7a5 5 0 0110 0zM9 7a3 3 0 106 0 3 3 0 00-6 0zm3 6c4.943 0 9 3.55 9 8a1 1 0 01-1 1H4a1 1 0 01-1-1c0-4.45 4.057-8 9-8zm0 2c-3.49 0-6.348 2.184-6.902 5h13.804l-.047-.215C18.201 17.073 15.4 15 12 15z"
        />
      </symbol>

      <symbol id="home" viewBox="0 0 16 18">
        <path fillRule="evenodd" clipRule="evenodd" d="M.5 6.5c0-.262.123-.51.333-.667l6.667-5a.833.833 0 011 0l6.667 5c.21.158.333.405.333.667v10c0 .46-.373.833-.833.833H1.333A.833.833 0 01.5 16.5v-10zm5.833 9.167h3.334v-3.334a1.667 1.667 0 10-3.334 0v3.334zm5 0v-3.334a3.333 3.333 0 00-6.666 0v3.334h-2.5v-8.75L8 2.542l5.833 4.375v8.75h-2.5z"/>
      </symbol>

      <symbol id="document" viewBox="0 0 14 18">
        <path fillRule="evenodd" clipRule="evenodd" d="M0 1a1 1 0 011-1h8a1 1 0 01.707.293l4 4A1 1 0 0114 5v12a1 1 0 01-1 1H1a1 1 0 01-1-1V1zm11.586 4L9 2.414V5h2.586zM7 2v4a1 1 0 001 1h4v9H2V2h5z" />
      </symbol>


      {/* <symbol id="logo" viewBox="0 0 108 139" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path fillRule="evenodd" clipRule="evenodd" d="M53.714 92.253v46H107.714v-46h-54z" fill="#FFAB00"/>
        <path fillRule="evenodd" clipRule="evenodd" d="M0 92.253c.427 0 .678.005 1.632 0 9.21-.062 34.837 19.696 44.758 27.792 3.538 2.886 7.412 7.136 7.524 11.81.08 3.274.086 4.147.086 6.398l-54-.01v-45.99z" fill="#FCD6D1"/>
        <path fillRule="evenodd" clipRule="evenodd" d="M53.714 46.495V77.63c0 8.209 6.333 14.864 14.147 14.864h39.853v-46h-54z" fill="#14335E"/>
        <path fillRule="evenodd" clipRule="evenodd" d="M53.714.737v46h8.961c0-10.468 8.077-18.952 18.04-18.952 9.96 0 18.037 8.485 18.037 18.952h8.962v-46h-54z" fill="#FFB08A"/>
        <path fillRule="evenodd" clipRule="evenodd" d="M54 .737c-.427 0-.678.007-1.632 0C43.158.677 17.53 20.435 7.61 28.53 4.07 31.417.198 35.667.086 40.339.006 43.613 0 44.489 0 46.737l54-.01V.737z" fill="#FC3D2E"/>
        <path fillRule="evenodd" clipRule="evenodd" d="M54 46.495V77.63c0 8.209-6.334 14.864-14.147 14.864H0v-46h54z" fill="#380D12"/>
      </symbol> */}

      <symbol id="arrow-right" viewBox="0 0 28 18" xmlns="http://www.w3.org/2000/svg">
        <path fillRule="evenodd" clipRule="evenodd" d="M17.821 16.845a1.667 1.667 0 010-2.357l3.822-3.821H2.333a1.667 1.667 0 110-3.334h19.31L17.82 3.512a1.667 1.667 0 012.357-2.357l6.667 6.666a1.661 1.661 0 01.36 1.822 1.66 1.66 0 01-.343.518l-.019.02-6.665 6.664c-.65.651-1.706.651-2.357 0z"/>
      </symbol>

      <symbol id="quotes" viewBox="0 0 346 260"xmlns="http://www.w3.org/2000/symbol">
        <path fillRule="evenodd" clipRule="evenodd" d="M346 183.529C346 224.314 309.851 260 268.537 260c-41.313 0-77.462-35.686-77.462-81.569 0-109.957 76.877-162.996 97.98-175.484L294.358 0l25.821 35.686s-41.313 25.49-51.642 71.373c41.314 0 77.463 35.686 77.463 76.47zM0 178.431C0 224.314 36.15 260 77.463 260c41.313 0 77.462-35.686 77.462-76.471 0-40.784-36.149-76.47-77.462-76.47 8.115-36.05 35.359-59.512 46.662-67.911l4.979-3.462L103.284 0S0 50.98 0 178.431z" fill="#140D12" fillOpacity=".05"/>
      </symbol>

    </svg>
  );
};
